import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface ExpandableTextProps {
    text: string;
    maxChars?: number;
    className?: string;
}

export function ExpandableText({
    text,
    maxChars = 120,
    className = '',
}: ExpandableTextProps) {
    const [expanded, setExpanded] = useState(false);

    const { t } = useTranslation();

    if (!text) return null;

    const isLong = text.length > maxChars;
    // Xác định nội dung hiển thị dựa trên trạng thái expanded
    const contentDisplayed = expanded ? text : text.slice(0, maxChars);

    return (
        <p className={`text-sm text-[#808080] break-words ${className}`}>
            {/* Render nội dung văn bản */}
            {contentDisplayed}

            {/* Render dấu ... nếu đang rút gọn */}
            {!expanded && isLong && '...'}

            {/* Nút bấm nằm cùng dòng (inline) */}
            {isLong && (
                <button
                    type="button"
                    className="text-white hover:underline inline font-medium ml-1"
                    onClick={() => setExpanded(!expanded)}
                >
                    {expanded ? t('Show less') : t('Show more')}
                </button>
            )}
        </p>
    );
}
